<template>
  <modal width="60%" :title="$t(title)" :visible.sync="isShowDialog">
    <el-form
      ref="form"
      :model="dioForm"
      style="position:relative"
      :rules="rules"
      label-width="auto"
      label-position="right"
    >
      <el-row :gutter="20">
        <el-col
          :span="12"
          v-if="sysAdmin === 'isSysAdmin' || sysAdmin === 'isSysNoAdmin'"
        >
          <el-form-item :label="$t('public.table_scope')" :prop="'sceneId'">
            <el-select
              v-model="dioForm.sceneId"
              style="width:250px"
              :placeholder="$t('public.please')"
              v-if="this.optareStatus === 'add'"
            >
              <el-option
                v-for="item in scopeArray"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <span v-else>{{ textChange(dioForm.sceneId, 's') }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('integration.sensor_nickname')"
            prop="nickname"
          >
            <el-input
              type="text"
              v-model.trim="dioForm.nickname"
              :placeholder="$t('public.please')"
              style="width:250px"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('integration.sensor_number')"
            :prop="'tagId'"
          >
            <el-input
              v-if="this.optareStatus === 'add'"
              type="text"
              v-model.trim="dioForm.tagId"
              :placeholder="$t('public.please')"
              style="width:250px"
            ></el-input>
            <span v-else>{{ dioForm.tagId }}</span>
          </el-form-item>
        </el-col>

        <el-col
          :span="12"
          :pull="
            !(sysAdmin === 'isSysAdmin' || sysAdmin === 'isSysNoAdmin') ? 0 : 0
          "
        >
          <el-form-item :label="$t('integration.sensor_type')" prop="type">
            <el-select
              @change="changeTypeFn"
              v-model="dioForm.type"
              style="width:250px"
              :placeholder="$t('public.please')"
              v-if="this.optareStatus === 'add'"
            >
              <el-option
                v-for="item in typeArray"
                :key="item.value"
                :label="`${$t(deviceTypeListConvert[item.code])}`"
                :value="item.value"
              ></el-option>
            </el-select>
            <span v-else>
              <span>{{ textChange(dioForm.type, 't') }}</span>
            </span>
          </el-form-item>
        </el-col>
      </el-row>
      <template v-if="typeId === 1 || typeId === 2">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$t('integration.acquisition_interval')"
              prop="collectInterval"
            >
              <el-input
                v-model.trim="dioForm.collectInterval"
                style="width: 250px"
                maxlength="50"
                :placeholder="$t('public.please_enter')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('integration.abnormal_collection_interval')"
              prop="exCollectInterval"
            >
              <el-input
                v-model.trim="dioForm.exCollectInterval"
                style="width: 250px"
                maxlength="50"
                :placeholder="$t('public.please_enter')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('Ext Pan ID')" prop="extPanId">
              <el-input
                v-model.trim="dioForm.extPanId"
                style="width: 250px"
                maxlength="50"
                :placeholder="$t('public.please_enter')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('Join Attemp')" prop="channelPage">
              <el-input
                v-model.trim="dioForm.channelPage"
                style="width: 250px"
                maxlength="50"
                :placeholder="$t('public.please_enter')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$t('device.transmit_power')"
              prop="transmitPower"
            >
              <el-input
                v-model.trim="dioForm.transmitPower"
                style="width: 250px"
                maxlength="50"
                :placeholder="$t('public.please_enter')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('device.channel_mask')" prop="channelMask">
              <el-input
                v-model.trim="dioForm.channelMask"
                style="width: 250px"
                maxlength="50"
                :placeholder="$t('public.please_enter')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$t('device.in_net_interval')"
              prop="inNetInterval"
            >
              <el-input
                v-model.trim="dioForm.inNetInterval"
                style="width: 250px"
                maxlength="50"
                :placeholder="$t('public.please_enter')"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template
        v-if="typeId === 3 || typeId === 4 || typeId === 5 || typeId === 6"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$t('integration.temperature_acquisition_interval')"
              prop="tempCollectInterval"
            >
              <el-input
                v-model.trim="dioForm.tempCollectInterval"
                style="width: 250px"
                maxlength="50"
                :placeholder="$t('public.please_enter')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('integration.temperature_change_threshold')"
              prop="tempChange"
            >
              <el-input
                v-model.trim="dioForm.tempChange"
                style="width: 250px"
                maxlength="50"
                :placeholder="$t('public.please_enter')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$t('integration.maximum_temperature_reporting_interval')"
              prop="tempMaxReport"
            >
              <el-input
                v-model.trim="dioForm.tempMaxReport"
                style="width: 250px"
                maxlength="50"
                :placeholder="$t('public.please_enter')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('integration.minimum_temperature_reporting_interval')"
              prop="tempMinReport"
            >
              <el-input
                v-model.trim="dioForm.tempMinReport"
                style="width: 250px"
                maxlength="50"
                :placeholder="$t('public.please_enter')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
            <el-col :span="12"></el-col>
            <el-col :span="12"></el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12"></el-col>
            <el-col :span="12"></el-col>
</el-row>-->
        <!-- 如果是温湿度情况 -->
        <template v-if="typeId === 4 || typeId === 6">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                :label="$t('integration.humidity_collection_interval')"
                prop="humCollectInterval"
              >
                <el-input
                  v-model.trim="dioForm.humCollectInterval"
                  style="width: 250px"
                  maxlength="50"
                  :placeholder="$t('public.please_enter')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('integration.humidity_change_threshold')"
                prop="humChange"
              >
                <el-input
                  v-model.trim="dioForm.humChange"
                  style="width: 250px"
                  maxlength="50"
                  :placeholder="$t('public.please_enter')"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                :label="$t('integration.maximum_humidity_reporting_interval')"
                prop="humMaxReport"
              >
                <el-input
                  v-model.trim="dioForm.humMaxReport"
                  style="width: 250px"
                  maxlength="50"
                  :placeholder="$t('public.please_enter')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('integration.humidity_minimum_reporting_interval')"
                prop="humMinReport"
              >
                <el-input
                  v-model.trim="dioForm.humMinReport"
                  style="width: 250px"
                  maxlength="50"
                  :placeholder="$t('public.please_enter')"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <!-- 网络参数 -->
        <template v-if="typeId === 3 || typeId === 4">
          <el-row :gutter="20">
            <!-- <el-col :span="12">
                <el-form-item :label="$t('DevEUI')" prop="devEui">
                    <el-input
                        v-model.trim="dioForm.devEui"
                        style="width: 250px"
                        maxlength="50"
                        :placeholder="$t('public.please_enter')"
                    />
                </el-form-item>
</el-col>-->
            <el-col :span="12">
              <el-form-item
                :label="$t('device.in_net_interval')"
                prop="inNetInterval"
              >
                <el-input
                  v-model.trim="dioForm.inNetInterval"
                  style="width: 250px"
                  maxlength="50"
                  :placeholder="$t('public.please_enter')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('AppEUI')" prop="appEui">
                <el-input
                  v-model.trim="dioForm.appEui"
                  style="width: 250px"
                  maxlength="50"
                  :placeholder="$t('public.please_enter')"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('AppKey')" prop="appKey">
                <el-input
                  v-model.trim="dioForm.appKey"
                  style="width: 250px"
                  maxlength="50"
                  :placeholder="$t('public.please_enter')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('device.channel_mask')"
                prop="channelMask"
              >
                <el-input
                  v-model.trim="dioForm.channelMask"
                  style="width: 250px"
                  maxlength="50"
                  :placeholder="$t('public.please_enter')"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-if="typeId === 5 || typeId === 6">
          <el-col :span="12">
            <el-form-item
              :label="$t('device.in_net_interval')"
              prop="inNetInterval"
            >
              <el-input
                v-model.trim="dioForm.inNetInterval"
                style="width: 250px"
                maxlength="50"
                :placeholder="$t('public.please_enter')"
              />
            </el-form-item>
          </el-col>
        </template>
      </template>

      <!--      二代温度计-->
      <template v-if="typeId === 7 || typeId === 8">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$t('public.work_mode')"
              prop="sampleMode"
              :rules="[RuleRequiredFunc('public.please_select_work_mode')]"
            >
              <el-select v-model="dioForm.sampleMode" style="width:250px">
                <el-option
                  :value="parseInt(key)"
                  :key="key"
                  :label="$t(item.title)"
                  v-for="(item, key) in secGenZigbeeTempMode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--Zigbee二代-异步模式-->
          <template v-if="dioForm.sampleMode === 1">
            <el-col :span="12">
              <el-form-item
                :label="$t('device.sample_interval')"
                prop="sampleInterval"
                :rules="[RuleRequiredFunc('device.please_enter_sample_interval')]"
              >
                <el-input
                  style="width: 250px"
                  v-model="dioForm.sampleInterval"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('device.normal_reporting_interval')"
                prop="sampleInterval"
                :rules="[RuleRequiredFunc('device.please_enter_normal_reporting_interval')]"
              >
                <el-input
                  style="width: 250px"
                  v-model="dioForm.normalReportInterval"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$t('device.abnormal_reporting_interval')"
                prop="sampleInterval"
                :rules="[RuleRequiredFunc('device.please_enter_abnormal_reporting_interval')]"
              >
                <el-input
                  style="width: 250px"
                  v-model="dioForm.abnormalReportInterval"
                ></el-input>
              </el-form-item>
            </el-col>
          </template>

          <!-- zigbee二代 - 同步模式-->
          <template v-else-if="dioForm.sampleMode === 2">
            <el-col :span="12">
              <el-form-item
                :label="$t('device.async_reporting_interval')"
                prop="syncInterval"
                :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
              >
                <el-input
                  style="width: 250px"
                  v-model="dioForm.syncInterval"
                ></el-input>
              </el-form-item>
            </el-col>
          </template>

          <!-- zigbee二代 - 固定模式-->
          <template v-else-if="dioForm.sampleMode === 3">
            <el-col :span="12">
              <el-form-item
                :label="$t('device.fixed_reporting_interval')"
                prop="gapInterval"
                :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
              >
                <el-input
                  style="width: 250px"
                  v-model="dioForm.gapInterval"
                ></el-input>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
      </template>
      <!--      4g温度计-->
      <template
        v-if="typeId === 9 || typeId === 10 || typeId === 11 || typeId === 12"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$t('public.work_mode')"
              prop="monitorMode"
              :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
            >
              <el-select v-model="dioForm.monitorMode" style="width:250px">
                <el-option
                  :value="parseInt(key)"
                  :key="key"
                  :label="$t(item.title)"
                  v-for="(item, key) in fourGSesnorMode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 4G温度计 区间变化量模式-->
          <template v-if="dioForm.monitorMode === 1">
            <el-col :span="12">
              <el-form-item
                :label="$t('device.sample_interval')"
                :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
                prop="sampleGap"
              >
                <el-input
                  style="width: 250px"
                  v-model="dioForm.sampleGap"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$t('device.max_recording_interval')"
                prop="maxRecGap"
                :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
              >
                <el-input
                  style="width: 250px"
                  v-model="dioForm.maxRecGap"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$t('device.min_recording_interval')"
                prop="minRecGap"
                :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
              >
                <el-input
                  style="width: 250px"
                  v-model="dioForm.minRecGap"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$t('device.max_change_amount')"
                prop="changeThreshold"
                :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
              >
                <el-input
                  style="width: 250px"
                  v-model="dioForm.changeThreshold"
                ></el-input>
              </el-form-item>
            </el-col>
          </template>

          <!--  4G温度计 同步模式-->
          <template v-else-if="dioForm.monitorMode === 2">
            <el-col :span="12">
              <el-form-item
                :label="$t('device.async_sample_interval')"
                prop="syncInterval"
                :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
              >
                <el-input
                  style="width: 250px"
                  v-model="dioForm.syncInterval"
                ></el-input>
              </el-form-item>
            </el-col>
          </template>

          <!--  4G温度计 固定模式-->
          <template v-else-if="dioForm.monitorMode === 3">
            <el-col :span="12">
              <el-form-item
                :label="$t('device.sample_interval')"
                prop="norRepGap"
                :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
              >
                <el-input
                  style="width: 250px"
                  v-model="dioForm.sampleGap"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('device.normal_reporting_interval')"
                prop="norRepGap"
                :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
              >
                <el-input
                  style="width: 250px"
                  v-model="dioForm.norRepGap"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$t('device.abnormal_reporting_interval')"
                prop="abnorRepGap"
                :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
              >
                <el-input
                  style="width: 250px"
                  v-model="dioForm.abnorRepGap"
                ></el-input>
              </el-form-item>
            </el-col>
          </template>

          <!--          声光报警设置-->
          <el-col :span="12">
            <!--            报警级别-->
            <el-form-item
              :label="$t('device.alarm_level')"
              prop="alarmLevel"
              :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
            >
              <el-select v-model="dioForm.alarmLevel" style="width: 250px">
                <el-option
                  v-for="(item, key) in fourGSensorAlarmLevel"
                  :key="key"
                  :label="$t(item.title)"
                  :value="parseInt(key)"
                  style="width: 250px"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <template v-if="dioForm.alarmLevel !== 0">
            <el-col :span="12">
              <!--            报警次数-->
              <el-form-item
                :label="$t('integration.number_of_alarms')"
                prop="alarmCycle"
                :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
              >
                <el-input
                  v-model="dioForm.alarmCycle"
                  style="width: 250px"
                ></el-input>
              </el-form-item>
            </el-col>
            <!--          报警间隔-->
            <el-col :span="12">
              <el-form-item
                :label="$t('integration.alarm_interval')"
                prop="alarmInterval"
                :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
              >
                <el-input
                  v-model="dioForm.alarmInterval"
                  style="width: 250px"
                ></el-input>
              </el-form-item>
            </el-col>
            <!--          报警持续时间-->
            <el-col :span="12">
              <el-form-item
                :label="$t('langText.Alarm_duration')"
                prop="alarmDuration"
                :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
              >
                <el-input
                  v-model="dioForm.alarmDuration"
                  style="width: 250px"
                ></el-input>
              </el-form-item>
            </el-col>
          </template>

          <!-- GPS定位 只有带GPS的才会展示-->
          <el-col :span="12" v-if="typeId === 11 || typeId === 12">
            <el-form-item
              :label="$t('integration.gps_p')"
              prop="gpsSwitch"
              :rules="[RuleRequiredFunc($t('integration.cannot_be_empty'))]"
            >
              <el-select v-model="dioForm.gpsSwitch" style="width: 250px">
                <el-option :label="$t('public.close')" :value="0"></el-option>
                <el-option :label="$t('public.open')" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('public.table_desc')" prop="description">
            <el-input
              v-model.trim="dioForm.description"
              style="width: 86%"
              maxlength="250"
              show-word-limit
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              :placeholder="$t('public.please_enter')"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-row style="z-index: -0">
        <el-col :span="24">
          <el-button type="primary" @click="isShowDialog = false"
            >{{ $t('public.btn_close') }}
          </el-button>
          <el-button type="primary" @click="handleSave"
            >{{ $t('public.btn_confirm') }}
          </el-button>
        </el-col>
      </el-row>
    </div>
  </modal>
</template>

<script>
import { sensorAddSensor } from '@/api/modules/sensor.js'
import { compileSensor } from '@/api/api.js'
import addRules from '@/pages/equipment/validate/addRules.js'
import { shareScope } from '@/api/modules/public'
import { getPermission } from '@/utils/permission'
import { fourGSesnorMode, secGenZigbeeTempMode, deviceTypeListConvert } from '@/utils/convert'
import { RuleRequiredFunc } from '@/utils/rules'
import { soundLightAlarmConfigDefault } from '@/pages/equipment/sensor/components/sensor/cionfig/4GTempTab/default'
import { fourGSensorAlarmLevel } from '@/utils/dict/sensor'
import { humpObject } from '@/utils/common'

export default {
  props: ['title', 'isShowUnDialog', 'optareStatus', 'editObj', 'deviceType'],
  computed: {
    fourGSensorAlarmLevel () {
      return fourGSensorAlarmLevel
    },
    fourGSesnorMode () {
      return fourGSesnorMode
    },
    secGenZigbeeTempMode () {
      return secGenZigbeeTempMode
    },
    deviceTypeListConvert: () => deviceTypeListConvert,
    isShowDialog: {
      get: function () {
        return this.isShowUnDialog
      },
      set: function (val) {
        this.$emit('update:isShowUnDialog', val)
      }
    },
    rules () {
      const tagId = {
        tagId: [
          {
            required: true,
            message: $t('integration.number_cannot_be_empty'),
            trigger: 'blur'
          },
          {
            max: 30,
            message: $t('integration.number_length_cannot_be_greater_than_30'),
            trigger: 'blur'
          }
        ]
      }
      const rules = addRules.call(
        this,
        'add',
        [
          'sceneId',
          'tagId',
          'nickname',
          'type',
          'extPanId',
          'channelPage',
          'channelMask',
          'transmitPower',
          'inNetInterval',
          'devEui',
          'appEui',
          'appKey',
          'collectInterval',
          'exCollectInterval',
          'tempCollectInterval',
          'tempChange',
          'tempMaxReport',
          'tempMinReport',
          'humCollectInterval',
          'humChange',
          'humMaxReport',
          'humMinReport'
        ],
        tagId
      )

      return rules
    },
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    }
  },
  watch: {
    editObj (newVal) {
      const appConfig = humpObject(newVal.appConfig || {})
      const sensor = humpObject(newVal.sensor || {})

      // 提取 sensor 的特有字段，避免被其他配置覆盖
      const sensorFields = {
        id: sensor.id,
        sceneId: sensor.sceneId,
        tagId: sensor.tagId,
        nickname: sensor.nickname,
        type: sensor.type,
        typeCode: sensor.typeCode,
        description: sensor.description
      }

      this.dioForm.sceneId = sensor.sceneId
      this.dioForm.tagId = sensor.tagId
      // 不同类型的传感器不同的处理方法
      switch (newVal.deviceType.id) {
        // 1~6一代温度计 有网络参数
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
          const netConfig = humpObject(newVal.netConfig)
          this.dioForm = {
            ...this.dioForm,
            ...appConfig,
            ...netConfig,
            ...sensorFields
          }
          break
        // 7~8 普通二代温度计  没有网络参数
        case 7:
        case 8:
          this.dioForm = {
            ...this.dioForm,
            ...appConfig,
            ...sensorFields
          }
          break
        // 9~10普通二代温度计 不带gps
        case 9:
        case 10:
          this.dioForm = {
            ...this.dioForm,
            ...humpObject(newVal.alarmConfig),
            ...appConfig,
            ...sensorFields
          }
          break
        // 11~12 二代温度计 带gps
        case 11:
        case 12:
          this.dioForm = {
            ...this.dioForm,
            ...(appConfig || {}),
            ...humpObject(newVal.alarmConfig || {}),
            gpsSwitch: (newVal.gpsConfig || {}).gpsSwitch,
            ...sensorFields
          }
          break
      }
      // this.dioForm = { ...newVal }
    }
  },
  data () {
    return {
      dioForm: {
        sceneId: null,
        nickname: null,
        tagId: null,
        type: null,
        typeCode: null,
        description: null,
        ...soundLightAlarmConfigDefault
      },
      scopeArray: [],
      typeArray: [],
      typeId: null
    }
  },
  mounted () {
    this.getSence()
    this.typeArray = [...this.deviceType]
  },
  methods: {
    RuleRequiredFunc,
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async handleSave () {
      const flag = await this.justify()
      if (!flag) return
      for (const key in this.dioForm) {
        if (this.dioForm[key] === null) {
          delete this.dioForm[key]
        }
      }

      let HttpUrl = sensorAddSensor
      if (this.optareStatus === 'edit') {
        HttpUrl = compileSensor
      } else {
        for (const item of this.typeArray) {
          if (this.dioForm.type === Number(item.value)) {
            this.dioForm.typeCode = item.code
            break
          }
        }
      }
      HttpUrl(this.dioForm).then(async ({ state }) => {
        await this.$resultHandle(state)
        this.isShowDialog = false
        this.$parent.getListFn()
      })
    },
    textChange (value, key) {
      let str = ''
      if (key === 's') {
        this.scopeArray.forEach(item => {
          if (item.id === String(value)) {
            str = item.name
          }
        })
      } else {
        this.typeArray.forEach(item => {
          if (item.value === value) {
            str = item.name
          }
        })
      }
      return this.$t(str)
    },
    getSence () {
      shareScope({ tab: 1 }).then(res => {
        if (res.state.code == 200) {
          this.scopeArray = res.result.filter(item => {
            return item.id > 0
          })
        }
      })
    },
    changeTypeFn (typeId) {
      // init dioForm
      const arrays = ['sceneId', 'tagId', 'type', 'nickname']
      for (const key in this.dioForm) {
        if (arrays.indexOf(key) == -1) {
          this.dioForm[key] = null
        }
      }
      const zigBeeArray = [
        {
          key: 'collectInterval',
          value: '600'
        },
        {
          key: 'exCollectInterval',
          value: '300'
        },
        {
          key: 'extPanId',
          value: '50414e4944303032'
        },
        {
          key: 'channelPage',
          value: '0'
        },
        {
          key: 'transmitPower',
          value: '10'
        },
        {
          key: 'channelMask',
          value: '11'
        },
        {
          key: 'inNetInterval',
          value: '900'
        }
      ]

      const publicArray = [
        {
          key: 'tempCollectInterval',
          value: '60'
        },
        {
          key: 'tempChange',
          value: '1'
        },
        {
          key: 'tempMaxReport',
          value: '900'
        },
        {
          key: 'tempMinReport',
          value: '60'
        }
      ]
      const humArray = [
        {
          key: 'humCollectInterval',
          value: '60'
        },
        {
          key: 'humChange',
          value: '1'
        },
        {
          key: 'humMaxReport',
          value: '900'
        },
        {
          key: 'humMinReport',
          value: '60'
        }
      ]

      const netArray = [
        // {
        //     key: 'devEui',
        //     value: '120'
        // },
        {
          key: 'appEui',
          value: '564D2D4555493031'
        },
        {
          key: 'appKey',
          value: '00000000000000000000000000000000'
        },
        {
          key: 'channelMask',
          value: '11'
        },
        {
          key: 'inNetInterval',
          value: '900'
        }
      ]

      const zetaNet = [
        {
          key: 'inNetInterval',
          value: '900'
        }
      ]
      let array = []

      if (typeId === 1 || typeId === 2) {
        array = [...zigBeeArray]
        // zigBeeArray.forEach(item => {
        //     this.$set(this.dioForm, item.key, item.value)
        // })
      } else {
        if (typeId === 4) {
          array = [...publicArray, ...humArray, ...netArray]
        } else if (typeId === 6) {
          array = [...publicArray, ...humArray, ...zetaNet]
        } else if (typeId === 3) {
          array = [...publicArray, ...netArray]
        } else {
          array = [...publicArray, ...zetaNet]
        }
      }
      array.forEach(item => {
        this.$set(this.dioForm, item.key, item.value)
      })

      this.typeId = typeId
    }
  }
}
</script>

<style></style>
